/**
 * @generated SignedSource<<8300505b71dbff61117171a6a86e77ba>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type AssetsVerticalVerticalInstantiationStatus = "COMPLETED" | "CREATED" | "DISABLED" | "FAILED" | "IN_PROGRESS" | "%future added value";
export type AssetsVerticalVerticalType = "HAM" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type GSNForContentSidebarEntryPoint$data = {
  readonly assetsVertical_checkPermissions?: {
    readonly __typename: "AssetsVerticalCheckPermissionsSuccess";
    readonly results: ReadonlyArray<{
      readonly permissionId: string;
      readonly permitted: boolean;
      readonly resourceId: string;
    }>;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
  readonly assetsVertical_tenantContext?: {
    readonly __typename: "AssetsVerticalTenantContextSuccess";
    readonly tenantContext: {
      readonly assetsVerticalWorkspaceAri: string | null;
    };
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
  readonly assetsVertical_verticalInstantiations?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly status: AssetsVerticalVerticalInstantiationStatus;
        readonly type: AssetsVerticalVerticalType;
      };
    }>;
  } | null;
  readonly growthRecommendations?: {
    readonly recommendations: {
      readonly __typename: "GrowthRecRecommendations";
      readonly context: {
        readonly product: string | null;
        readonly sessionId: string | null;
        readonly tenantId: string | null;
        readonly useCase: string | null;
      } | null;
      readonly data: ReadonlyArray<{
        readonly entityId: string;
        readonly reasons: ReadonlyArray<string> | null;
        readonly score: number | null;
      }> | null;
    } | {
      readonly __typename: "QueryError";
      readonly extensions: ReadonlyArray<{
        readonly errorType: string | null;
        readonly statusCode: number | null;
      }> | null;
      readonly identifier: string | null;
      readonly message: string | null;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null;
  } | null;
  readonly navPlatL1MenuData: {
    readonly " $fragmentSpreads": FragmentRefs<"useNavSettingsService">;
  } | null;
  readonly navPlatSidebarData: {
    readonly " $fragmentSpreads": FragmentRefs<"useNavSettingsService">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"Nav4Apps" | "Nav4Filters" | "Nav4Operations" | "Nav4Plans" | "Nav4Projects" | "Nav4Roadmaps_query" | "useGlobalShortcutsDataRelay" | "useNetworkSideNavUserData" | "useShowRoadmapsUpsell">;
  readonly " $fragmentType": "GSNForContentSidebarEntryPoint";
};
export type GSNForContentSidebarEntryPoint$key = {
  readonly " $data"?: GSNForContentSidebarEntryPoint$data;
  readonly " $fragmentSpreads": FragmentRefs<"GSNForContentSidebarEntryPoint">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "ownerAri",
  "variableName": "ownerAri"
},
v1 = [
  {
    "kind": "FragmentSpread",
    "name": "useNavSettingsService"
  }
],
v2 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v3 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "kind": "RootArgument",
      "name": "currentURL"
    },
    {
      "kind": "RootArgument",
      "name": "fetchGlobalShortcutsAvailableProducts"
    },
    {
      "kind": "RootArgument",
      "name": "invitedAppShortcutsProduct"
    },
    {
      "kind": "RootArgument",
      "name": "isItamEnabled"
    },
    {
      "kind": "RootArgument",
      "name": "isRoadmapUpsellEnabled"
    },
    {
      "kind": "RootArgument",
      "name": "itamStaticChecks"
    },
    {
      "kind": "RootArgument",
      "name": "navPlatMenuDataEntityAri"
    },
    {
      "kind": "RootArgument",
      "name": "navPlatSidebarDataEntityAri"
    },
    {
      "kind": "RootArgument",
      "name": "ownerAri"
    },
    {
      "kind": "RootArgument",
      "name": "shouldFetchInvitedAppShortcuts"
    }
  ],
  "kind": "Fragment",
  "name": "GSNForContentSidebarEntryPoint",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "useNetworkSideNavUserData"
    },
    {
      "condition": "isRoadmapUpsellEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "useShowRoadmapsUpsell"
        }
      ]
    },
    {
      "condition": "fetchGlobalShortcutsAvailableProducts",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "useGlobalShortcutsDataRelay"
        }
      ]
    },
    {
      "alias": "navPlatL1MenuData",
      "args": [
        {
          "kind": "Variable",
          "name": "entityAri",
          "variableName": "navPlatMenuDataEntityAri"
        },
        (v0/*: any*/)
      ],
      "concreteType": "SettingsNavigationCustomisation",
      "kind": "LinkedField",
      "name": "settings_navigationCustomisation",
      "plural": false,
      "selections": (v1/*: any*/)
    },
    {
      "alias": "navPlatSidebarData",
      "args": [
        {
          "kind": "Variable",
          "name": "entityAri",
          "variableName": "navPlatSidebarDataEntityAri"
        },
        (v0/*: any*/)
      ],
      "concreteType": "SettingsNavigationCustomisation",
      "kind": "LinkedField",
      "name": "settings_navigationCustomisation",
      "plural": false,
      "selections": (v1/*: any*/)
    },
    {
      "kind": "FragmentSpread",
      "name": "Nav4Apps"
    },
    {
      "kind": "FragmentSpread",
      "name": "Nav4Filters"
    },
    {
      "kind": "FragmentSpread",
      "name": "Nav4Operations"
    },
    {
      "kind": "FragmentSpread",
      "name": "Nav4Plans"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "currentURL",
          "variableName": "currentURL"
        }
      ],
      "kind": "FragmentSpread",
      "name": "Nav4Projects"
    },
    {
      "kind": "FragmentSpread",
      "name": "Nav4Roadmaps_query"
    },
    {
      "condition": "isItamEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": [
            (v2/*: any*/)
          ],
          "kind": "LinkedField",
          "name": "assetsVertical_tenantContext",
          "plural": false,
          "selections": [
            (v3/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "concreteType": "AssetsVerticalTenantContext",
                  "kind": "LinkedField",
                  "name": "tenantContext",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "assetsVerticalWorkspaceAri"
                    }
                  ]
                }
              ],
              "type": "AssetsVerticalTenantContextSuccess"
            }
          ]
        },
        {
          "args": [
            {
              "kind": "Variable",
              "name": "checks",
              "variableName": "itamStaticChecks"
            },
            (v2/*: any*/)
          ],
          "kind": "LinkedField",
          "name": "assetsVertical_checkPermissions",
          "plural": false,
          "selections": [
            (v3/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "concreteType": "AssetsVerticalPermissionCheckResult",
                  "kind": "LinkedField",
                  "name": "results",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "resourceId"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "permissionId"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "permitted"
                    }
                  ]
                }
              ],
              "type": "AssetsVerticalCheckPermissionsSuccess"
            }
          ]
        },
        {
          "args": [
            (v2/*: any*/),
            {
              "kind": "Literal",
              "name": "first",
              "value": 100
            },
            {
              "kind": "Literal",
              "name": "type",
              "value": "HAM"
            }
          ],
          "concreteType": "AssetsVerticalVerticalInstantiationConnection",
          "kind": "LinkedField",
          "name": "assetsVertical_verticalInstantiations",
          "plural": false,
          "selections": [
            {
              "concreteType": "AssetsVerticalVerticalInstantiationEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "AssetsVerticalVerticalInstantiation",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "id"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "type"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "status"
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "condition": "shouldFetchInvitedAppShortcuts",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "concreteType": "GrowthRecQuery",
          "kind": "LinkedField",
          "name": "growthRecommendations",
          "plural": false,
          "selections": [
            {
              "args": [
                {
                  "fields": [
                    {
                      "kind": "Variable",
                      "name": "product",
                      "variableName": "invitedAppShortcutsProduct"
                    },
                    {
                      "kind": "Variable",
                      "name": "tenantId",
                      "variableName": "cloudId"
                    },
                    {
                      "kind": "Literal",
                      "name": "useCase",
                      "value": "invitedAppShortcuts"
                    }
                  ],
                  "kind": "ObjectValue",
                  "name": "context"
                }
              ],
              "kind": "LinkedField",
              "name": "recommendations",
              "plural": false,
              "selections": [
                (v3/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "name": "data",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "entityId"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "reasons"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "score"
                        }
                      ]
                    },
                    {
                      "concreteType": "GrowthRecContextResult",
                      "kind": "LinkedField",
                      "name": "context",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "tenantId"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "product"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "useCase"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "sessionId"
                        }
                      ]
                    }
                  ],
                  "type": "GrowthRecRecommendations"
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "identifier"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "message"
                    },
                    {
                      "kind": "LinkedField",
                      "name": "extensions",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "statusCode"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "errorType"
                        }
                      ]
                    }
                  ],
                  "type": "QueryError"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "0f1d7b02d17d46d4a7d59e034770a937";

export default node;
